import Link from 'next/link';
import type { AnchorHTMLAttributes, ReactNode } from 'react';

type SmartLinkProps = {
	href: string;
	children: ReactNode;
	newTab?: boolean;
	className?: string;
} & AnchorHTMLAttributes<HTMLAnchorElement>;

const SmartLink = ({ href, children, newTab, className, ...rest }: SmartLinkProps) => {
	const isExternal = /^https?:\/\//.test(href);
	// newTab true / false forces a new tab / the same tab; left unset, absolute http(s) links open a new tab.
	const opensNewTab = newTab ?? isExternal;
	const target = opensNewTab ? '_blank' : undefined;
	const rel = opensNewTab ? 'noopener noreferrer' : undefined;

	if (isExternal) {
		return (
			<a href={href} className={className} target={target} rel={rel} {...rest}>
				{children}
			</a>
		);
	}

	return (
		<Link href={href} className={className} target={target} rel={rel} {...rest}>
			{children}
		</Link>
	);
};

export default SmartLink;
